// extracted by mini-css-extract-plugin
module.exports = {"loginBlock":"LoginPage_loginBlock__30A3q","loginCard":"LoginPage_loginCard__a0YGY"};